import { apiAdmin } from './cliente';

export const listarTenants = () => apiAdmin.get('/api/v1/tenants');
